export const REPORT_ID = 'slide-18';
export const SLIDE_NUMBER = 18;